import { render, staticRenderFns } from "./VerticalFloatingIcons.vue?vue&type=template&id=19f1000e&scoped=true"
import script from "./VerticalFloatingIcons.vue?vue&type=script&lang=js"
export * from "./VerticalFloatingIcons.vue?vue&type=script&lang=js"
import style0 from "./VerticalFloatingIcons.vue?vue&type=style&index=0&id=19f1000e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f1000e",
  null
  
)

export default component.exports